import React, { Component } from 'react';
import KeyboardKeyTampa from './KeyboardKeyTampa';
import _ from 'lodash';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import FontAwesome from 'react-fontawesome'
import { connect } from 'react-redux';
import { shallowEqual, presetDp, dp } from '../../../utils/shared.js'
import donorHelpers from '../../../utils/donorHelpers.js'
import dataHelpers from '../../../utils/dataHelpers.js'
import StoryTampa from './StoryTampa'
// import InfoBlockTampa from './InfoBlockTampa';
import BackButtonTampa from './BackButtonTampa';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import BRSpan from '../../General/BRSpan';
import InfoBlockTampa from './InfoBlockTampa';
const DARK = "#71532c"
// import axios from 'axios'
// import config from '../../../../config';

// const SUBSCRIBE = "subscribe";
// const SEARCH = "search";

class UserInputTampa extends Component {

  constructor(props) {
    super(props);
    this.state = {
      text: "",
      module: this.props.module,
      virtual_keyboard_mode: 0,
      iScrollInitialized: false,
      scrollContainerHeight: "50vh",
      storyRefs: [],
      hideKeyboard: false,
      emailSent: false,
      showStory: false,
      renderedStories: [],
      renderedDonors: []
    }

    this._regionWidth = this.props.screen.screenWidth * 2.25;
    this._storiesRefs = [];
    this._donorListNames = [];
    this._simple = null;
    this._simpleWithPictures = null;
    this._videos = null;
    this._donors = null;
    this._pills = null;
    this._resultsContainer = null;
    this._emailSentTimeout = null;
    this._pillsStorySetsByModules = [];
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.deleteText = this.deleteText.bind(this);
    this.normalMode = this.normalMode.bind(this);
    this.capitalMode = this.capitalMode.bind(this);
    this.submitText = this.submitText.bind(this);

    this.getTimelineModule();

    //Refs
    this._storyPillsRefs = [];
  }

  componentDidMount() {
    this._donorListNames = this.setupDonorListsNames();
  }

  // componentWillMount(){
  //   checkData(this.props.module, this.props.screen.entry_point);
  //   this._emailSentTimeout = null;
  //   clearTimeout(this._emailSentTimeout);
  // }

  shouldComponentUpdate(prevProps, prevState) {
      if (shallowEqual(this.state, prevState)) {
          return false;
      }
      return true;
  }

  setupDonorListsNames = () => {
    let folders = _.filter(this.props.content.story_categories, { contents: { custom_fields: { folder_type: { val: { value: "donor_list" } } } } });
    folders = this.filterNonDescendant(folders);
    let names = [];
    if (folders && folders.length > 0) {
      for (let i = 0; i < folders.length; i++) {
        let searchable = _.get(folders[i], 'contents.custom_fields.searchable.val', true);
        if (searchable) {
          let folder = folders[i];
          let folderTree = this.getFolderTree(folder, 0);          
          let name = "";
          let subName = "";
          let parentId = null;
          let parent;

          if (folderTree.count <= 4) {
            let child = folderTree.child;
            parent = { ...child };
            while(child) {
              if (child.child) {
                child = child.child;
                parent = { ...child };
              } else {
                name = child.name;
                parentId = parent.parent_category;
                child = null;
              }
            }

            names.push({
              id: folder.id,
              name: name,
              subName: null,
              parentId: parentId
            });
          }

          if (folderTree.count === 5) {
            let child = folderTree.child;
            while(child) {
              if (child.child) {
                name = child.name;
                child = child.child;
                parent = { ...child };
              } else {
                subName = child.name;
                parentId = parent.parent_category;
                child = null;
              }
            }

            names.push({
              id: folder.id,
              name: name,
              subName: subName,
              parentId: parentId
            });
          }
        }
      }
    }

    return names;
  }

  getFolderTree = (folder, count) => {
    count++;
    if (folder.parent_category === undefined || folder.parent_category === null) {
      folder.count = count;
      return folder;
    } else {
      let parentFolder = _.find(this.props.content.story_categories, { id: folder.parent_category });
      parentFolder.child = folder;
      return this.getFolderTree(parentFolder, count);
    }
  }

  handleKeyPress(val) {
    if (typeof val === "function") {
      val();
    }
    else {
      let str = this.state.text + val;
      if (str.length < 40) {
        this.setState({
          text: str
        })
      }
    }

  }

  normalMode() {
    this.setState({
        virtual_keyboard_mode: 0
    })
  }

  capitalMode() {
    this.setState({
        virtual_keyboard_mode: 1
    })
  }

  deleteText() {
    if (this.state.text.length > 0) {
      let str = this.state.text.substring(0, this.state.text.length - 1);
      this.setState({
        text: str
      })
    }
  }

  submitText() {
    this.setState({
      iScrollInitialized: false
    });

    this._pillsStorySetsByModules = [];
    this._storyPillsRefs = [];
    this._storyPillsRefs.length = 0;

    let donorResults = donorHelpers.searchInFolderDonorLists(this.props.content.story_categories, this.props.donors, this.state.text);
    let storiesResult = dataHelpers.searchStory(this.props.content, this.state.text, ['attract_loop']);
    this.renderStories(storiesResult);
    this.renderDonors(donorResults);

    this.setState({
      stories: storiesResult,
      donors: this._donors,
      hideKeyboard: true
    });

    setTimeout(() => {
      this.setState({
        search: true
      });
      setTimeout(() => {
        if (this.iScroller) {
          this.iScroller._iScrollInstance.refresh();
        }
      }, 500)
    }, 500);
  }

  getBackgroundImage = () => {
    let defaultImg = {path:'/img/miami/general/', file_name:'default_single_screen.jpg'}
    let backgroundObj = _.get(this.props.module, 'contents.images[0]', null);
    return dp(this.props.screen, backgroundObj, defaultImg);
  }

  getIconImage = () => {
    let iconObj = _.get(this.props.module, 'contents.images[2]', null);
    return dp(this.props.screen, iconObj);
  }

  getTimelineModule = () => {
		this._menuModules = _.filter(this.props.content.dm_active, { module_contents: { in_navigation: true } });
		this._menuModules.forEach((module, row) => {
			if (module.display_module_type === "Timeline") {
        this._timelineModule = module;
			}
		});
	}

  removeInputText = () => {
    this.setState({
      text: "",
      search: false,
      hideKeyboard: false
    });
  }

  initializeIScroll = () => {
    if (this.state.iScrollInitialized === false) {
      for (let i = 0; i < this._storiesRefs.length; i++) {
        if (this._storiesRefs[i] && this._storiesRefs[i].el) {
          this._storiesRefs[i].el.addEventListener("tap", () => this.handleTap(this._storiesRefs[i].data.id));
        }
      }

      this.setState({
        iScrollInitialized: true
      })
    }
  }

  handleTap = (id) => {
    let story = this.props.content.stories.find(st => st.id === id);

    if (this.state.showModal) {
      this.setState({
        showModal: false
      });

      clearTimeout(this._modalTimeout);
      this._modalTimeout = null;
      this._modalTimeout = setTimeout(() => {
        this.setState({
          story: story,
          showModal: true
        });
      }, 500);
    } else {
      this.setState({
        story: story,
        showModal: true
      });
    }
  }

  handleBack = () => {
    this.props.showNavButton(true);
    this.setState({
      showModal: false
    });
  }

  handleSearchBack = () => {
    this.setState({
      hideKeyboard: false,
      search: false,
      text: ""
    })
  }
  
	redirect = () => {
    if (this._timelineModule !== null && this._timelineModule !== undefined) {
			this.props.navRoute('/miami/timeline', this._timelineModule);
		}
  }

  getDonorListName = (folder) => {
    let name = _.find(this._donorListNames, { id: folder.id });
    return name;
  }
  
  getGrouppedDonorFolders = (folders) => {
    let parents = []
    for (let i = 0; i < folders.length; i++) {
      let name = this.getDonorListName(folders[i]);
      if (name && parents.indexOf(name.parentId) === -1) {
        parents.push(name.parentId);
      }
    }

    return parents;
  }

  getTributes = (donor) => {
    let renderedTributes = []
    if (donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options) {
      renderedTributes = donor.contents.arrays_values.acknowledgment_text_options.map((opt, i) => {
        return (
          <div key={i}>
            <div style={{ paddingTop: this._regionWidth * .0035, paddingBottom: this._regionWidth * .0035  }}>{`${opt.acknowledgment_text_options.val.title} ${opt.donor_name.val}`}</div>
          </div>
        );
      });
    }

    return renderedTributes;
  }

  filterNonDescendant = (folders) => {
    let rootFolder = _.get(this.props.content, 'settings.selected_root_folder', null);
    let filteredFolders = [];
    if (!rootFolder) {
      return folders;
    }

    for (let i = 0; i < folders.length; i++) {
      if (folders[i].parent_category === null || folders[i].parent_category === undefined) {
        continue;
      }

      let parent = folders[i].parent_category;
      while (parent !== null && parent !== undefined) {
        if (Number(parent) === Number(rootFolder)) {
          filteredFolders.push(folders[i]);
          break;
        }
        // eslint-disable-next-line 
        let parentsParent = this.props.content.story_categories.find(st => Number(st.id) === Number(parent));
        parent = parentsParent.parent_category;
      }
    }

    return filteredFolders;
  }

  renderStories = (stories) => {
    if (stories.length === 0) {
      this.setState({
        renderedStories: []
      });
      return;
    }

    let rows = [];
    let row = [];
    for (let i = 0; i < stories.length; i++) {
      let slide = stories[i];
      // let image = presetDp('stories', _.get(slide, 'contents.images[0]', null), this.props.screen);
      // let marginLeft = 0;
      
      // if (i > 0 && (i % 3 !== 0)) {
      //   marginLeft = 0.0225 * this._regionWidth;
      // } else {
      //   marginLeft = 0;
      // }
      
      if ((i % 3 === 0 && i > 0)) {
        rows.push(row);
        row = [];
      }

      let story = this.renderStory(slide, i);
      
      // let story = (
      //   <div key={i} ref={el => this._storiesRefs[i] = { el: el, data: { id: slide.id } }} style={{ position:"relative", marginLeft: marginLeft, float:"left", height:0.09 * this._regionWidth, display:"flex", justifyContent:"center", alignItems:"flex-end", minWidth:"25%", maxWidth:"25%" }}>
      //     <img src={image} style={{ maxWidth:0.10125 * this._regionWidth, maxHeight:0.074925 * this._regionWidth }} alt=""/>
      //     <div style={{ position: "absolute", bottom: -(0.0468 * this._regionWidth), width: 0.10125 * this._regionWidth, textAlign: "center", display: "flex", justifyContent: "center", minHeight: 0.04166666666666666667 * this._regionWidth, maxHeight: 0.04166666666666666667 * this._regionWidth, overflow: "hidden" }}>
      //       <div style={{ fontSize: 0.0084 * this._regionWidth }}><BRSpan preWrap str={slide.name.toUpperCase()}/></div>
      //     </div>
      //   </div>
      // );

      row.push(story);
      if (i === stories.length - 1) {
        rows.push(row);
      }
    }

    let renderedRows = rows.map((row, j) => {
      let marginTop = j === 0 ? 0 : this._regionWidth * 0.017;
      return (
        <div key={j} style={{ position:"relative", display:"flex", alignItems:"center", justifyContent:"center", width: "89%", height: "15.0462962962962962963vh", marginTop: marginTop, margin: "0 auto" }}>
          {row}
        </div>
      );
    });
    this.setState({
      renderedStories: renderedRows
    });
  }

  renderStory = (row, i) => {
    const unit = this.props.screen.r9_16.p10 / this.props.screensNumber;
    let backgroundObj = _.get(this.props.menu, 'contents.images[0]', null);
    let backgroundImage =  presetDp(null, backgroundObj, this.props.screen);
    let mult = .8
    return (
      <div key={i} ref={el => this._storiesRefs[i] = { el: el, data: { id: row.id } }} style={{ marginRight: unit * .175, display: 'inline-block' }}>
        <InfoBlockTampa
          imgsrc={presetDp('stories', _.get(row, 'contents.images[0]', null), this.props.screen)}
          imageHeight={unit * 2 * mult}
          infoHeight={"4.6875vh"}
          width={"15vh"}
          unit={unit * mult}
          text={row.name}
          infoColor={"black"}
          infoBackgroundColor={'white'}
          backgroundImage={backgroundImage}
          fontFamily={'opensans-regular'}
          fontSize={unit * 0.15}
        />
      </div>
    )
  }

  renderDonors = (results) => {
    let renderedDonors = [];
    let renderedSubDonors = [];
    let count = 0;
    let marginTop = 0;

    let foundFolders = _.filter(this.props.content.story_categories, fl => results.foundFolders.indexOf(Number(fl.id)) > -1);
    let parents =  this.getGrouppedDonorFolders(foundFolders);
    let parentFolders = _.filter(this.props.content.story_categories, fl => parents.indexOf(Number(fl.id)) > -1);

    for (let i = 0; i < parentFolders.length; i++) {
      const enablePalqueText = _.get(parentFolders[i], 'contents.custom_fields.enable_palque_text.val', false);
      let children = _.filter(foundFolders, { parent_category: parentFolders[i].id });
      for (let j = 0; j < children.length; j++) {
        const folder = children[j];
        const donorCategoryName = this.getDonorListName(folder);
        const { subName } = donorCategoryName;
        let searchable = _.get(folder, 'contents.custom_fields.searchable.val', true);
        if (searchable) {
          let categoryMatchedDonors = _.orderBy(_.filter(results.foundDonors, { folder_module: { folder: folder.id } }), [donor => donor.sorting_name.toLowerCase()], ['asc']);

          if (enablePalqueText) {
            const columnDonors = categoryMatchedDonors.map((donor, i) => {
              const palqueText = _.get(donor, 'contents.texts[0].text', null);
              let marginBottom = donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options ? .004 * this._regionWidth : 0;
              return (
                <div key={i} style={{ width: "100%", textAlign: "left", minHeight: 0.013 * this._regionWidth, display: "block", paddingTop: .0052 * this._regionWidth }}>
                  <div style={{ maxWidth: "85%", fontSize: 0.0075 * this._regionWidth, marginBottom: marginBottom }}>{donor.name}</div>
                  {
                    palqueText ?
                    <div style={{ marginLeft: "5%", maxWidth: "80%", fontSize: 0.0075 * this._regionWidth }}>
                      {palqueText}
                    </div>
                    : null
                  }
                </div>
              );              
            });

            renderedSubDonors[j] = (
              <div key={j} style={{ 
                background:"white", 
                margin: "0 auto", 
                width: this.props.screen.screenWidth * 0.6687242798353909465,
                paddingBottom: this.props.screen.screenHeight * 0.01875,
                paddingTop: this.props.screen.screenHeight * 0.02893518518518518519,
                borderRadius: 10,
                paddingLeft: this.props.screen.screenWidth * 0.074074074,
                paddingRight: this.props.screen.screenWidth * 0.074074074,
                marginBottom: this.props.screen.screenWidth * .06172839506172839506
               }}
              >
                {
                  subName ?
                  <div className="opensans-bold" style={{ fontSize: "1.85185185185185185185vh", paddingTop: 0.00347222222222222222 * this._regionWidth, paddingBottom: 0.00694444444444444444 * this._regionWidth, color:"#694f28" }}>
                    <BRSpan preWrap str={subName.toUpperCase()} />
                  </div>
                  :null
                }
                <div style={{ position: "relative", width: "100%", display: "flex", marginTop: .004 * this._regionWidth, marginBottom: 0.0086 * this._regionWidth }}>
                  <div className="opensans-regular" style={{ width: "100%", float: "left" , color:"black"}}>
                    {columnDonors}
                  </div>
                </div>
              </div>
            );
          } else {
            let matchedColumnOne = [];
            let matchedColumnTwo = [];
            // Highlighted Donors (matched)
            for (let k = 0; k < categoryMatchedDonors.length; k++) {
              if (k === 0 || k % 2 === 0) {
                matchedColumnOne.push(categoryMatchedDonors[k]);
              } else {
                matchedColumnTwo.push(categoryMatchedDonors[k]);
              }
            }
    
            let renderedMatchedColumnOneDonors = matchedColumnOne.map((donor, i) => {
              let marginBottom = donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options ? .004 * this._regionWidth : 0;
              return (
                <div key={i} style={{ width: "100%", textAlign: "left", minHeight: 0.013 * this._regionWidth, display: "block", paddingTop: .0052 * this._regionWidth }}>
                  <div style={{ maxWidth: "85%", fontSize: 0.009 * this._regionWidth, marginBottom: marginBottom }}>{donor.name}</div>
                  <div style={{ marginLeft: "5%", maxWidth: "80%", fontSize: 0.0075 * this._regionWidth }}>
                    {this.getTributes(donor)}
                  </div>
                </div>
              );
            });
    
            let renderedMatchedColumnTwoDonors = matchedColumnTwo.map((donor, i) => {
              let marginBottom = donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options ? .004 * this._regionWidth : 0;
              return (
                <div key={i} style={{ width: "100%", textAlign: "left", minHeight: 0.013 * this._regionWidth, display: "block", paddingTop: .0052 * this._regionWidth }}>
                  <div style={{ maxWidth: "85%", fontSize: 0.009 * this._regionWidth, marginBottom: marginBottom }}>{donor.name}</div>
                  <div style={{ marginLeft: "5%", maxWidth: "80%", fontSize: 0.0075 * this._regionWidth }}>
                    {this.getTributes(donor)}
                  </div>
                </div>
              );
            });
            if (count > 0) {
              marginTop = .026 * this._regionWidth;
            }
    
            renderedSubDonors[j] = (
              <div key={j} style={{ 
                background:"white", 
                margin: "0 auto", 
                width: this.props.screen.screenWidth * 0.6687242798353909465,
                paddingBottom: this.props.screen.screenHeight * 0.01875,
                paddingTop: this.props.screen.screenHeight * 0.02893518518518518519,
                borderRadius: 10,
                paddingLeft: this.props.screen.screenWidth * 0.074074074,
                paddingRight: this.props.screen.screenWidth * 0.074074074,
                marginBottom: this.props.screen.screenWidth * .06172839506172839506
               }}
              >
                {
                  subName ?
                  <div className="opensans-bold" style={{ fontSize: "1.85185185185185185185vh", paddingTop: 0.00347222222222222222 * this._regionWidth, paddingBottom: 0.00694444444444444444 * this._regionWidth, color:"#694f28" }}>
                    <BRSpan preWrap str={subName.toUpperCase()} />
                  </div>
                  :null
                }
                {/* <div style={{ position: "absolute", height: this._regionWidth * 0.0017, background: "white", width: "90%" }} /> */}
                <div style={{ position: "relative", width: "100%", display: "flex", marginTop: .004 * this._regionWidth, marginBottom: 0.0086 * this._regionWidth }}>
                  <div className="opensans-regular" style={{ width: 0.16875 * this._regionWidth, float: "left" , color:"black"}}>
                    {renderedMatchedColumnOneDonors}
                  </div>
                  <div className="opensans-regular" style={{ width: 0.16875 * this._regionWidth, color:"black" }}>
                    {renderedMatchedColumnTwoDonors}
                  </div>
                </div>
              </div>
            );
          }
        }
      }

      renderedDonors[i] = (
        <div key={i} style={{ position: "relative", width:"100%", marginTop: marginTop }}>
          {/* <div className="opensans-semibold" style={{ fontSize: this._regionWidth * 0.015625, color:"black" }}>
            <BRSpan preWrap str={parentFolders[i].name.toUpperCase()}/>
          </div> */}
          {renderedSubDonors}
        </div>
      );
      renderedSubDonors = [];
    }

    this.setState({
      renderedDonors: renderedDonors
    });
  }

  renderBackButton = () => {
    return (
      <BackButtonTampa
        unit={this.props.screen.r9_16.p10 / this.props.screensNumber}
        width="3.90625vh"
        height="4.5vh"
        top="56.46875vh"
        border="0.84375vh"
        clickAction={this.handleBack}
        text={'back'}
        mode={this._mode}>
      </BackButtonTampa>
    );
  }

  renderBackSearchButton = () => {
    return (
      <BackButtonTampa
        unit={this.props.screen.r9_16.p10 / this.props.screensNumber}
        width="3.90625vh"
        height="4.5vh"
        top="56.46875vh"
        border="0.84375vh"
        clickAction={this.handleSearchBack}
        text={'back'}
        mode={this._mode}>
      </BackButtonTampa>
    );
  }

  render() {
    const backgroundImage = this.getBackgroundImage();
    const iconImage = this.getIconImage();
    const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;
    
    const textShadowSize = Math.ceil(this.props.screen.screenHeight * 0.003);
    const textShadow = `${textShadowSize}px ${textShadowSize}px ${textShadowSize}px black`;
    
    let mod = .6;

    let keystd = {
      width: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.9 * mod,
      height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
      margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
      borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.15 * mod,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
      fontSize:".98vh"
    }

    let keyspace = {
      width: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.6 * mod,
      height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
      margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
      borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.15 * mod,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
      fontSize:".98vh"
    }

    let keycom = {
      width: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.6 * mod,
      height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
      margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
      borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.15 * mod,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
      fontSize:".98vh"
    }

    let keysubmit = {
      width: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.6 * mod,
      height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
      margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
      borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.5 * mod,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
    }

    const unit = this.props.screen.r9_16.p10   
    const textAlign = this.state.text.length > 0 ? "center":"left"; 

    const hasMatchedResults = this.state.renderedStories.length > 0 || this.state.renderedDonors.length > 0;
    const horizontalRadius = this.props.screen.screenHeight * .00520833333333333333;
    const verticalRadius = this.props.screen.screenHeight * .00651041666666666667;
    let margins = {
      descriptionTop: this.props.screen.screenHeight * .00651041666666666667
    }
    const sizes = {
      title: this.props.screen.screenHeight * .02199074074074074074,
      description: this.props.screen.screenHeight * .01388888888888888889
    }

    //move just the keyboard input mode into redux, so that this state doesn't need to be passed from parent to child, or alternatively use a parent->child or child->parent watch.

    if (!this.props.module){
      return <span />
    }

    return (
      <div>
        {/* Modal */}
        <CSSTransitionGroup
          component='div'
          className="containerFade"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.hideKeyboard} style={{ zIndex:9999 }}>
            {
              this.state.hideKeyboard && !this.state.showModal ?
              this.renderBackSearchButton() : null
            }
          </div>
          <div key={this.state.showModal} style={{ zIndex:99999 }}>
            {
              this.state.showModal ?
                <StoryTampa
                backgroundImage={backgroundImage}
                showBackground={true}
                screen={this.props.screen}
                screensNumber={this.props.screensNumber}
                navRoute={this.props.navRoute}
                story={this.state.story}
                mode="image"
                clickAction={this.handleBack}
                contentIndex={this.state.storyIndex}
                />
                :
                null}
            {this.state.showModal ? this.renderBackButton() : null}
          </div>
        </CSSTransitionGroup>

        {/* Screen */}
        <div style={{ width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundImage: "url(" + backgroundImage + ")", backgroundSize: backgroundSize }} >
          <div style={{ position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber }} >
            {/* Header */}
            <div style={{ display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' }}>
              <div style={{ height: "4vh" }}>
              </div>
              <img alt={this.props.module.name} src={iconImage} style={{ width: '14vh' }} />
            </div>
            <div className="crimson-semi-bold" style={{ textShadow: textShadow, textAlign: "center", fontSize: '4vh' }}>
              {this.props.module.name}
            </div>
            <div style={{ width:"100%", display:"flex", justifyContent: "center" }}>
              <div className="crimson-regular" style={{ textShadow: textShadow, fontSize: '2vh', textAlign: "center", width:"85%", lineHeight: this.props.screen.screenWidth * .03240740740740740741 + "px" }}>
                {this.props.module.description}
              </div>              
            </div>
            {/* <div className="topgradblackP25" style={{ position: "absolute", width: '100%', height: unit * .25, top: "32.916666667vh", left: 0 }} /> */}
            <div className="topgradblackP25" style={{ position:"absolute", width: '100%', height: unit * .25, top: "26.979166667vh", left: 0 }} />

            {/* Keyboard */}
            <CSSTransitionGroup
              component='div'
              transitionName='example'
              transitionEnterTimeout={0}
              transitionLeaveTimeout={0}>
              <div key={this.state.hideKeyboard}>
                {
                  !this.state.hideKeyboard ?
                  <div>
                    <div style={{ height: '12vh' }} />
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div style={{ display: 'inline-block', width: '45vh', height: "5.83vh", border: "0.3125vh", borderStyle: "solid", borderColor: "#FFFFFF", borderRadius: this.props.screen.r9_16.p10 * 0.8, backgroundColor: "#153f7e" }}>
                        <span style={{ height: "6.16667vh", display: 'flex', alignItems: 'center', justifyContent: textAlign, fontSize: "1.6vh", color: "white", float: "left", width: "90%" }}>
                          {
                            this.state.text.length > 0 ?
                              <div>&nbsp;{this.state.text}&nbsp;</div>
                              : <div style={{ fontSize: "2.5vh", fontWeight: "bold" }}>
                                <div style={{ marginLeft: "6vh" }}>
                                      Enter a donor name
                                </div>
                              </div>
                          }
                          <FontAwesome style={{ fontSize: "2.5vh", position: "absolute", left: "7.8125vh" }} name='search' />
                        </span>
                        <span onClick={this.removeInputText} style={{ height: "4.166666667vh", display: 'flex', fontSize: "2vh", color: "white", float: "right", paddingTop: "1.9375vh", paddingRight: "2vh", fontWeight: "bold" }}>
                        <FontAwesome name='times' />
                      </span>
                      </div>
                    </div>
                    <div style={{ color: 'black', width: '85%', height: "30vh", display: "block", marginLeft: "auto", marginRight: "auto", }}>
                      {/* <div style={{ height: '5vh' }} /> */}
                      <div className="helem" style={{ position: "relative", paddingTop: "2vh" }}>
                        <div>
                          <KeyboardKeyTampa keyval={[1, 1, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[1, 1, null]} />
                          <KeyboardKeyTampa keyval={[2, 2, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[2, 2, null]} />
                          <KeyboardKeyTampa keyval={[3, 3, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[3, 3, null]} />
                          <KeyboardKeyTampa keyval={[4, 4, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[4, 4, null]} />
                          <KeyboardKeyTampa keyval={[5, 5, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[5, 5, null]} />
                          <KeyboardKeyTampa keyval={[6, 6, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[6, 6, null]} />
                          <KeyboardKeyTampa keyval={[7, 7, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[7, 7, null]} />
                          <KeyboardKeyTampa keyval={[8, 8, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[8, 8, null]} />
                          <KeyboardKeyTampa keyval={[9, 9, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[9, 9, null]} />
                          <KeyboardKeyTampa keyval={[0, 0, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[0, 0, null]} />
                          <KeyboardKeyTampa keyval={[this.deleteText, this.deleteText, this.deleteText]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['DELETE', 'DELETE', 'DELETE']} />
                          <br />

                          <KeyboardKeyTampa keyval={['q', 'Q', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['q', 'Q', null]} />
                          <KeyboardKeyTampa keyval={['w', 'W', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['w', 'W', null]} />
                          <KeyboardKeyTampa keyval={['e', 'E', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['e', 'E', null]} />
                          <KeyboardKeyTampa keyval={['r', 'R', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['r', 'R', null]} />
                          <KeyboardKeyTampa keyval={['t', 'T', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['t', 'T', null]} />
                          <KeyboardKeyTampa keyval={['y', 'Y', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['y', 'Y', null]} />
                          <KeyboardKeyTampa keyval={['u', 'U', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['u', 'U', null]} />
                          <KeyboardKeyTampa keyval={['i', 'I', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['i', 'I', null]} />
                          <KeyboardKeyTampa keyval={['o', 'O', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['o', 'O', null]} />
                          <KeyboardKeyTampa keyval={['p', 'P', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['p', 'P', null]} />
                          <KeyboardKeyTampa keyval={['@', null, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['@', '@', null]} />
                          <br />

                          <KeyboardKeyTampa keyval={['a', 'A', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['a', 'A', null]} />
                          <KeyboardKeyTampa keyval={['s', 'S', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['s', 'S', null]} />
                          <KeyboardKeyTampa keyval={['d', 'D', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['d', 'D', null]} />
                          <KeyboardKeyTampa keyval={['f', 'F', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['f', 'F', null]} />
                          <KeyboardKeyTampa keyval={['g', 'G', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['g', 'G', null]} />
                          <KeyboardKeyTampa keyval={['h', 'H', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['h', 'H', null]} />
                          <KeyboardKeyTampa keyval={['j', 'J', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['j', 'J', null]} />
                          <KeyboardKeyTampa keyval={['k', 'K', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['k', 'K', null]} />
                          <KeyboardKeyTampa keyval={['l', 'L', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['l', 'L', null]} />
                          <KeyboardKeyTampa keyval={['_', '_', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['_', '_', null]} />
                          <KeyboardKeyTampa keyval={['&', '&', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['&', '&', null]} />
                          <br />

                          <KeyboardKeyTampa keyval={['z', 'Z', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['z', 'Z', null]} />
                          <KeyboardKeyTampa keyval={['x', 'X', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['x', 'X', null]} />
                          <KeyboardKeyTampa keyval={['c', 'C', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['c', 'C', null]} />
                          <KeyboardKeyTampa keyval={['v', 'V', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['v', 'V', null]} />
                          <KeyboardKeyTampa keyval={['b', 'B', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['b', 'B', null]} />
                          <KeyboardKeyTampa keyval={['n', 'N', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['n', 'N', null]} />
                          <KeyboardKeyTampa keyval={['m', 'M', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['m', 'M', null]} />
                          <KeyboardKeyTampa keyval={['.', '.', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['.', '.', null]} />
                          <KeyboardKeyTampa keyval={['-', '-', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['-', '-', null]} />
                          <KeyboardKeyTampa keyval={['*', '*', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['*', '*', null]} />
                          <KeyboardKeyTampa keyval={['?', '?', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['?', '?', null]} />

                          <br />
                          <div style={keystd}><span className="kspn-tampa">=/#</span></div>
                          <KeyboardKeyTampa keyval={[this.capitalMode, this.normalMode, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['UPCASE', 'DOWNCASE', null]} />
                          <KeyboardKeyTampa keyval={[' ', ' ', ' ']} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keyspace} contents={['Space', 'Space', 'Space']} />
                          <KeyboardKeyTampa keyval={['.com', '.com', '.com']} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keycom} contents={['.com', '.com', '.com']} />
                          <KeyboardKeyTampa searchStr={this.searchStr} keyval={['Submit', 'Submit', 'Submit']} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.submitText} mainstyle={keysubmit} contents={['Submit', 'Submit', 'Submit']} />
                        </div>
                      </div>
                    </div>
                  </div>
                  :null
                }

                <CSSTransitionGroup
                  component='div'
                  className="containerFade"
                  style={{ minHeight: '100%' }}
                  transitionName='example'
                  transitionEnterTimeout={0}
                  transitionLeaveTimeout={0}>
                  <div key={this.state.search} style={{ width: "90%", marginLeft: "auto", marginRight: "auto", position: "relative", height: "73.046875vh", touchAction:"none", top: "7.71604938271604938272vh" }}>
                  {
                    this.state.search && !this.state.showStory ?
                    <ReactIScroll ref={el => this.iScroller = el} iScroll={iScroll}
                      options={{
                        mouseWheel: true,
                        scrollbars: false,
                        scrollX: false,
                        scrollY: true,
                        probeType: 2,
                        bounce: false,
                        momentum: true,
                        deceleration: 0.005,
                        useTransition: true,
                        disableTouch: false,
                        disablePointer: false,
                        disableMouse: false,
                        tap: true
                      }}
                      onRefresh={this.initializeIScroll}
                    >
                      <div style={{ position: "relative" }}>
                        {
                          this.state.renderedStories && this.state.renderedStories.length > 0 ?
                          <div style={{ width:"89%", margin:"0 auto" }}>
                            <div style={{ height: "5vh" }}></div>
                            <div style={{ height:this._regionWidth * 0.0347 }}>
                              <span style={{ textShadow: textShadow, fontSize: this._regionWidth * 0.015625 }}>STORIES</span>
                              <div style={{ boxShadow: textShadow, position:"absolute", height: this._regionWidth * 0.0017, background:"white", width:"90%" }}/>
                            </div>
                          </div>
                          :null
                        }
                        {
                          this.state.renderedStories && this.state.renderedStories.length > 0 ?
                          this.state.renderedStories : null
                        }
                        {
                          this.state.renderedStories && this.state.renderedStories.length > 0
                          && this.state.renderedDonors && this.state.renderedDonors.length > 0 ?
                          <div style={{ width:"100%", height:this._regionWidth * 0.034 }}></div>
                          : null
                        }

                        {
                          this.state.renderedDonors.length > 0 && this.state.renderedStories.length === 0 ?
                          <div style={{ height:"5vh" }}/> : null
                        }
                        
                        {
                          this.state.renderedDonors && this.state.renderedDonors.length > 0 ?
                          <div style={{ width:"89%", margin: "0 auto" }}>
                            <div style={{ height:this._regionWidth * 0.0347 }}>
                              <span style={{ textShadow: textShadow, fontSize: this._regionWidth * 0.015625 }}>DONOR LIST</span>
                              <div style={{ boxShadow: textShadow, position:"absolute", height: this._regionWidth * 0.0017, background:"white", width:"90%" }}/>
                            </div>
                          </div>
                          :null
                        }

                        {
                          this.state.renderedDonors && this.state.renderedDonors.length > 0 ?
                          this.state.renderedDonors : null
                        }

                        {
                          !hasMatchedResults ?
                          <div style={{ height:"6vh", backgroundColor: "white", position:"relative", top:"10vh", width:"85%", margin: "0 auto", boxShadow: `${horizontalRadius}px ${verticalRadius}px ${verticalRadius}px 0px rgba(0,0,0,0.85)`, borderRadius: this.props.screen.screenWidth * .03472222222222222222, paddingTop: "3vh", paddingBottom: "3vh" }}>
                            <div style={{ fontSize: sizes.title, float:"left", textAlign:"center", width:"100%", color: DARK }} className="crimson-semi-bold">
                              <b>Sorry, no results...</b>
                            </div>
                            <div className="opensans-regular" style={{ fontSize: sizes.description, float:"left", maxHeight: "6vh", overflow:"hidden", textAlign:"center", width:"100%", marginTop: margins.descriptionTop, display:"-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient:"vertical", color: DARK }}>
                              Use the Back button to perform a new search
                            </div>
                          </div>
                          : null
                        }

                        <div style={{ height: .03375 * this._regionWidth }} />
                      </div>
                    </ReactIScroll>
                    :
                    null
                  }
                  </div>
                </CSSTransitionGroup>
              </div>
            </CSSTransitionGroup>
          
            {/* Email Sent Thank you */}
            {/* <CSSTransitionGroup
              component='div'
              transitionName='example'
              transitionEnterTimeout={0}
              transitionLeaveTimeout={0}>
              {
                this.state.emailSent ?
                <div key={this.state.emailSent}>
                  <div style={{ height: "11vh" }} />
                  <div style={{ margin: "auto", width: (this.props.screen.screenWidth / this.props.screensNumber) * 0.85, display: "table", lineHeight: '140%', marginTop: '1.5vh', backgroundColor: 'white', fontSize: '1.96875vh', fontFamily: "opensans-bold", color: '#404040', borderTopLeftRadius: unit * 0.08, borderTopRightRadius: unit * 0.08, borderBottomLeftRadius: unit * 0.08, borderBottomRightRadius: unit * 0.08 }}>
                    <div style={{ ...boxStyle, display: "table-cell" }}>
                      <div style={{ marginTop: '1.125vh', position: 'relative', fontSize: "2.1875vh" }}>
                        Thank you
                      </div>
                      <div style={{ fontSize: '.9vh', lineHeight: '140%', fontFamily: "opensans" }}>
                        We have received your email and will be in touch. Thank you for your interest
                      </div>
                    </div>
                    <div style={{ height: "2vh" }} />
                    <br />
                  </div>
                </div>
                :null
              }
            </CSSTransitionGroup> */}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.content,
    donors: state.donors,
  };
};

export default connect(mapStateToProps, null)(UserInputTampa);


// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/UserInputTampa.jsx